import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LogService } from '../../logging/log.service';
import { NavigationService } from '../../navigation/navigation.service';
import { LocationContextService } from '../location-context.service';

@Component({
    selector: 'app-centerline-group-selection',
    templateUrl: './centerline-group-selection.component.html'
})
export class CenterlineGroupSelectionComponent implements OnInit, OnDestroy {
    LOG_SOURCE = 'CenterlineGroupSelectionComponent';
    sub: Subscription;
    selectedTerminal: string;
    centerlineGroups: string[];
    backButtonAvailable: boolean;

    constructor(
        private readonly locationContextService: LocationContextService,
        private readonly navigationService: NavigationService,
        private readonly logService: LogService
    ) {}

    ngOnInit() {
        this.locationContextService.clearSelectedCenterlineGroup();

        if (!this.locationContextService.isTerminalSelected()) {
            this.navigationService.redirectToTerminalSelection();
        } else {
            this.backButtonAvailable = this.navigationService.getTerminalOptionsCount() > 1;
            this.selectedTerminal = this.locationContextService.getSelectedTerminal();

            this.locationContextService.requestCenterlineGroups(this.locationContextService.getSelectedTerminal());

            this.sub = this.locationContextService.getCenterlineGroups().subscribe(centerlineGroups => {
                this.centerlineGroups = centerlineGroups;

                this.navigationService.setCenterlineGroupOptionsCount(centerlineGroups.length);

                // Redirect automatically if only 1 option is available
                if (centerlineGroups.length === 1) {
                    const centerlineGroup = centerlineGroups[0];

                    this.logService.info(
                        this.LOG_SOURCE,
                        `Centerline Group '${centerlineGroup}' is selected automatically because it is the only available option`,
                        { centerlineGroup }
                    );

                    this.setSelectedCenterlineGroupAndRedirect(centerlineGroup, true);
                }
            });
        }
    }

    setSelectedCenterlineGroupAndRedirect(centerlineGroup: string, singleCenterlineGroup: boolean) {
        this.logService.info(this.LOG_SOURCE, `Selected centerline group '${centerlineGroup}'`, {
            centerlineGroup
        });
        this.locationContextService.setSelectedCenterlineGroup(centerlineGroup, singleCenterlineGroup);
        this.navigationService.redirectToCenterlineSelection();
    }

    isSingleTerminal() {
        return this.locationContextService.isSingleTerminal();
    }

    redirectBack() {
        this.logService.info(this.LOG_SOURCE, 'Resetting location context data', {});
        this.locationContextService.resetLocationContextData();
        this.logService.info(this.LOG_SOURCE, 'Redirecting user back', {});
        this.navigationService.redirectToTerminalSelection();
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
